import { render, staticRenderFns } from "./RemunerationStatements.vue?vue&type=template&id=b5eece1e&"
import script from "./RemunerationStatements.vue?vue&type=script&lang=js&"
export * from "./RemunerationStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports